import { render, staticRenderFns } from "./rewardRankEdit.vue?vue&type=template&id=4f81f6a2&scoped=true&"
import script from "./rewardRankEdit.vue?vue&type=script&lang=js&"
export * from "./rewardRankEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f81f6a2",
  null
  
)

export default component.exports